<template>
  <div>
    <h1 class="page-header">{{ $t('room.pageTitle') }}</h1>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-4">
            <ts-button
              color="info"
              outline
              @click="$router.push({ name: 'room-create' })"
            >
              {{ $t('add_new') }}
            </ts-button>
          </div>
          <div class="col-sm-8 d-flex justify-content-end">
            <ts-branch-filter @filter="value => (branch_id = value)" />
            <ts-input
              v-model="search"
              :placeholder="$t('Search')"
              style="width: 300px"
              class="kh-font"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-loading-banner :loading="exporting">
          <Table
            :columns="columns"
            :data="resources"
            :loading="loading"
            max-height="700"
            stripe
            highlight-row
             size="small"
          >
            <template slot-scope="{ row }" slot="branch_name_en">
              {{ row.branch !== null ? row.branch.branch_name_en : '' }}
            </template>
            <template slot-scope="{ row }" slot="room_type">
              {{ row.room_type !== null ? row.room_type.room_type : '' }}
            </template>
            <template slot-scope="{ row }" slot="building_name">
              {{ row.building !== null ? row.building.building_name : '' }}
            </template>
            <template slot-scope="{ row }" slot="room_desc">
              {{ $store.getters.limitStringShow(row.room_desc) }}
            </template>
            <template slot-scope="{ row }" slot="action">
              <a
                href="#"
                title="Edit"
                class="mr-2 text-primary"
                @click.prevent="edit(row)"
              >
                <i class="fas fa-edit"></i>
              </a>
              <a
                href="#"
                title="Delete"
                class="text-danger"
                @click.prevent="destroy(row)"
                :disabled="row._deleting"
              >
                <i class="fas fa-circle-notch spin" v-if="row._deleting"></i>
                <i class="fas fa-trash" v-else></i>
              </a>
            </template>
          </Table>
        </ts-loading-banner>
      </div>
      <div class="d-flex justify-content-between align-items-center p-15">
        
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
export default {
  name: 'room',
  data () {
    return {
      loading: false,
      exporting: false,
      branch_id: []
    }
  },
  created () {
    this.fetchData()
  },
  computed: {
    ...mapState('room', ['resources', 'pagination']),
    search: {
      get () {
        return this.$store.state.room.search
      },
      set (newValue) {
        this.$store.commit('room/SET_SEARCH', newValue)
        this.$store.commit('room/RESET_CURRENT_PAGE')
      }
    },
    columns () {
      return [
        {
          title: this.$t('room.branch'),
          slot: 'branch_name_en',
          minWidth: 80
        },
        { title: this.$t('room.name'), key: 'room_name', minWidth: 100 },
        { title: this.$t('room.capacity'), key: 'capacity', minWidth: 80 },
        { title: this.$t('room.roomtype'), slot: 'room_type', minWidth: 80 },
        { title: this.$t('room.floor'), key: 'floor_no', minWidth: 80 },
        {
          title: this.$t('room.building'),
          slot: 'building_name',
          minWidth: 100
        },
        {
          title: this.$t('room.description'),
          slot: 'room_desc',
          minWidth: 100
        },
        {
          title: this.$t('actions'),
          key: 'action',
          slot: 'action',
          fixed: 'right',
          align: 'center',
          width: 100
        }
      ]
    }
  },
  methods: {
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch(
          'room/fetch',
          Object.assign({}, attributes, { branch_id: this.branch_id })
        )
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit (record) {
      this.$store.commit('room/SET_FOUND_DATA', record)
      this.$router.push({
        name: 'room-edit',
        params: { id: record.room_id }
      })
    },

    async destroy (record) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        record._deleting = true
        this.$store
          .dispatch('room/destroy', record.room_id)
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search, branch_id: this.branch_id })
    }, 500),
    branch_id: debounce(function (value) {
      this.fetchData({ branch_id: value })
    }, 500)
  },
  beforeRouteLeave (to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'room-create') {
      this.$store.commit('room/RESET_STATE')
      this.$store.commit('room/SET_FOUND_DATA', {})
      this.$store.commit('room/SET_BUILDINGS', [])
      this.$store.commit('room/SET_ROOM_TYPES', [])
    }
    next()
  }
}
</script>
